module.exports = __webpack_public_path__ + "img/pazarcloud-pro.4f73e068.png";